import { Injectable } from "@angular/core";
import {Router, Routes} from "@angular/router";
import { HhsgSharedSideNavHeader, HhsgSharedSideNavMenuItem } from "../models";

@Injectable()
export class RouteUtil {
    public static getHeaderByRoute(headers: HhsgSharedSideNavHeader[], route: string): HhsgSharedSideNavHeader {
        let header: HhsgSharedSideNavHeader;

        headers.forEach(h => {
            if ((h.routeUrl && h.routeUrl?.length > 0 && route.includes(h.routeUrl)) || this.getMenuItemByRoute([ h ], route)) {
                header = h;
            }
        });

        return header;
    }

    public static getMenuItemByRoute(headers: HhsgSharedSideNavHeader[], route: string): HhsgSharedSideNavMenuItem {
        let menuItems = headers.filter(h => h.menuItems && h.menuItems.length > 0).flatMap(h => h.menuItems);
        let menuItem = menuItems.filter(x=>x.route?.length > 0).find(m => route?.includes(m.route));

        // If a menu item wasn't found, attempt to find it by sub menu item.  Sometimes a menu item doesn't actual route anywhere
        // but the sub menu item does.
        if (!menuItem) {
            let subMenuItem = this.getSubMenuItemByRoute(headers, route);

            if (subMenuItem) {
                menuItem = menuItems.find(m => m.subMenuItems && m.subMenuItems.length > 0
                                           && m.subMenuItems.some(s => route?.length > 0 && route?.includes(s.route)));
            }
        }

        return menuItem;
    }

    public static getSubMenuItemByRoute(headers: HhsgSharedSideNavHeader[], route: string): HhsgSharedSideNavMenuItem {
        return headers.filter(h => h.menuItems && h.menuItems.length > 0)
                      .flatMap(h => h.menuItems)
                      .filter(m => m.subMenuItems && m.subMenuItems.length > 0)
                      .flatMap(m => m.subMenuItems)
                      .find(s => route?.length > 0 && route?.includes(s.route));
    }

    public static routeExists(router: Router, routePath: string): boolean {
      // Remove leading slash from routePath
      routePath = routePath.replace(/^\//, '');

      // Traverse the router config recursively
      const traverseRoutes = (routes: Routes): boolean => {
        for (const route of routes) {
          // Check if the current route path matches the desired route path
          if (route.path === routePath) {
            return true;
          }

          // If the current route has children, traverse them recursively
          if (route.children) {
            const childRouteExists = traverseRoutes(route.children);
            if (childRouteExists) {
              return true;
            }
          }
        }

        return false;
      };

      // Call the traverseRoutes function with the router's config
      return traverseRoutes(router.config);
    }
}
